module.exports = __webpack_public_path__ + "static/media/ddd.b603a1b9.png";